import { Component, signal } from '@angular/core';
import { TranslatePipe } from '@admin-core/i18n/translate.pipe';
import { AiMarketingAssistantComponent } from './ai-marketing-assistant.component';

@Component({
  selector: 'app-ai-marketing-assistant-widget',
  standalone: true,
  imports: [TranslatePipe, AiMarketingAssistantComponent],
  templateUrl: './ai-marketing-assistant-widget.component.html',
  styleUrl: './ai-marketing-assistant-widget.component.scss'
})
export class AiMarketingAssistantWidgetComponent {
  readonly open = signal(false);

  toggle(): void {
    this.open.update((value) => !value);
  }

  close(): void {
    this.open.set(false);
  }
}
